import React from 'react'
import { Formik, Form, Field, FormikHelpers } from 'formik'
import * as yup from 'yup'
import { Button, Link, InputField, Checkbox } from 'components'
import classes from './InquiryForm.module.scss'
import { useTranslation } from 'react-i18next'

interface InquiryFormValues {
  subject: string
  content: string
  acceptPrivacyPolicy: boolean
}

const initialValues: InquiryFormValues = {
  subject: '',
  content: '',
  acceptPrivacyPolicy: false,
}

const validationSchema = yup.object({
  subject: yup
    .string()
    .required('pages.inquiries.inquiryForm.validation.subject'),
  content: yup
    .string()
    .required('pages.inquiries.inquiryForm.validation.content'),
  acceptPrivacyPolicy: yup
    .bool()
    .oneOf([true], 'pages.inquiries.inquiryForm.validation.required'),
})

interface InquiryFormProps {
  onSubmit: (
    values: InquiryFormValues,
    formikHelpers: FormikHelpers<InquiryFormValues>
  ) => void
}

export const InquiryForm: React.FunctionComponent<InquiryFormProps> = ({
  onSubmit,
}) => {
  const { t } = useTranslation()
  return (
    <Formik
      initialValues={initialValues}
      validationSchema={validationSchema}
      onSubmit={onSubmit}
    >
      <Form>
        <Field
          component={InputField}
          id="subject"
          name="subject"
          label={t('pages.inquiries.inquiryForm.subject')}
          type="text"
          maxLength="50"
        />

        <Field
          component={InputField}
          textarea
          id="content"
          name="content"
          label={t('pages.inquiries.inquiryForm.content')}
          rows={10}
          placeholder={t('pages.inquiries.inquiryForm.contentPlaceholder')}
          maxLength="3000"
        />

        <Field
          component={Checkbox}
          type="checkbox"
          id="acceptPrivacyPolicy"
          name="acceptPrivacyPolicy"
          label={
            <>
              {t('pages.inquiries.inquiryForm.dataSecurity.iHave')}{' '}
              <Link
                variant="inline"
                to={
                  process.env.PUBLIC_URL +
                  '/Datenschutzhinweise_MBAM_2025_04.pdf'
                }
                target="_blank"
                className={classes.links}
              >
                {t('pages.inquiries.inquiryForm.dataSecurity.policy')}
              </Link>{' '}
              {t('pages.inquiries.inquiryForm.dataSecurity.completeRead')}
            </>
          }
          className={classes.checkbox}
        />

        <Button id="submit-button-e2e" type="submit" aria-label="Submit">
          {t('global.send')}
        </Button>
      </Form>
    </Formik>
  )
}
